import React from 'react';
import { AlertCircleIcon, CheckCircle2Icon, ClockIcon, FrownIcon, ShieldAlertIcon, ShieldIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
const costs = [[ClockIcon, '120 horas de tu vida por año', '3 horas de planificación × 40 semanas. Tiempo que recuperás desde hoy con los 6 tomos y las 30 clases ya listas.'], [AlertCircleIcon, 'Alumnas que se estancan', 'Progresiones inventadas en el momento significan etapas salteadas. Sin criterios de avance medibles, el progreso se detiene y no sabés por qué.'], [FrownIcon, 'No sabés si tu trabajo funciona', 'Sin sistema de evaluación no hay métricas: ni para vos, ni para la charla con los padres al cierre del trimestre.'], [ShieldAlertIcon, 'Grupos mixtos sin sistema', 'Sin material diferenciado por nivel, entrenás al promedio: las que van adelante se aburren y las que arrancan se frustran.']] as const;
export function GuaranteeAndCost() {
  return <>
      <section className="border-y border-line bg-surface px-4 py-12 md:py-16" data-id="element-129" data-mp="3sg8s7dfbu119">
        <div className="mx-auto max-w-3xl text-center" data-id="element-130" data-mp="3se5r9ycmynhr">
          <span aria-hidden="true" className="inline-flex rounded-full border-2 border-gold bg-gold/10 p-5" data-id="element-131" data-mp="19ffbcb68dgw">
            <ShieldIcon className="h-10 w-10 text-gold" data-id="element-132" data-mp="62s69t3bowct" />
          </span>
          <div className="mt-5" data-id="element-133" data-mp="azqww1ns2l69">
            <Eyebrow data-id="element-134" data-mp="fz3gmdjcrc4m">🛡️ Garantía 7 días — sin preguntas</Eyebrow>
          </div>
          <SectionTitle data-id="element-135" data-mp="g17sbhnhtffg">
            Probalo 7 días. Si no te sirve,{' '}
            <span className="text-gold" data-id="element-136" data-mp="k187x5mbvwo3">te devolvemos el 100%.</span>
          </SectionTitle>
          <div className="mt-7 rounded-2xl border border-line bg-ink p-6 text-left font-medium leading-relaxed text-zinc-400 md:p-8" data-id="element-137" data-mp="oyi4d584x8lf">
            <p data-id="element-138" data-mp="2lug03fn1i8re">
              Abrís los tomos. <b className="text-white" data-id="element-139" data-mp="2qqd36k9alim8">Los usás en el gimnasio con tus alumnas.</b>
            </p>
            <p className="mt-3" data-id="element-140" data-mp="3u1afmmqudqjk">
              Y si en 7 días no es lo que esperabas, escribís a compradigitalyaa@gmail.com y te
              devolvemos el 100% del dinero.
            </p>
            <div className="mt-4 flex flex-wrap gap-4 text-sm font-bold text-white" data-id="element-141" data-mp="6xvwef3jshv4">
              {['Sin formularios', 'Sin esperas', 'Sin drama'].map(text => <span key={text} className="flex items-center gap-1.5" data-id="element-142" data-mp="20duv9rv14x5">
                  <CheckCircle2Icon aria-hidden="true" className="h-5 w-5 text-gold" data-id="element-143" data-mp="gtz8ods45wvs" />
                  {text}
                </span>)}
            </div>
          </div>
          <p className="mt-6 text-lg font-bold text-white" data-id="element-144" data-mp="pmssmoii9kfz">
            El riesgo no es tuyo. <span className="text-gold" data-id="element-145" data-mp="lm0htqtzj7hl">Es nuestro.</span>
          </p>
          <div className="mt-6 grid grid-cols-3 gap-3 text-center" data-id="element-146" data-mp="zm1j37e5wgxl">
            <Metric value="<1%" label="Tasa de devoluciones" data-id="element-147" data-mp="zmbamzeuuw5e" />
            <Metric value="+300" label="Entrenadores que ya lo usan" data-id="element-148" data-mp="unqat13imehh" />
            <Metric value="7 días" label="Garantía sin condiciones" data-id="element-149" data-mp="1e8qp7s2x5scy" />
          </div>
        </div>
      </section>

      <section className="px-4 py-12 md:py-16" data-id="element-150" data-mp="1j8d5ybhyhqqi">
        <div className="mx-auto max-w-4xl" data-id="element-151" data-mp="1j721saklmgyv">
          <Eyebrow danger data-id="element-152" data-mp="14at1r6svvzle">⚖️ El costo real</Eyebrow>
          <SectionTitle data-id="element-153" data-mp="14ab0twva0x75">
            ¿Cuánto te cuesta <span className="text-red-400" data-id="element-154" data-mp="199dvcndmrl0v">NO tenerlo?</span>
          </SectionTitle>
          <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-155" data-mp="vi91y30uvoyz">
            {costs.map(([CostIcon, label, cost]) => <li key={label} className="flex gap-3 rounded-xl border border-line bg-surface p-4" data-id="element-156" data-mp="109hc51a0fed7">
                <span aria-hidden="true" className="h-fit rounded-lg border border-red-500/30 bg-red-500/10 p-2" data-id="element-157" data-mp="llmfj9svspuu">
                  <CostIcon className="h-5 w-5 text-red-400" data-id="element-158" data-mp="cj4vn20p89b0" />
                </span>
                <p data-id="element-159" data-mp="gli0lo7mg36q">
                  <b className="block text-sm text-white" data-id="element-160" data-mp="gjx6fzp7ym9e">{label}</b>
                  <span className="text-sm font-medium text-zinc-500" data-id="element-161" data-mp="9hii2hc0dvp7">{cost}</span>
                </p>
              </li>)}
          </ul>
          <p className="mt-10 rounded-2xl border border-gold/25 bg-surface p-6 text-center text-lg font-bold text-zinc-300 md:text-2xl" data-id="element-162" data-mp="4j77u5hsxj6g">
            El domingo puede volver a empezar el mismo ciclo.
            <br data-id="element-163" data-mp="3qxqm826s0ycx" />
            <span className="text-gold" data-id="element-164" data-mp="3qw74s89dwh9k">
              O el próximo entrenamiento puede ser el mejor del año.
            </span>
          </p>
          <div className="mt-8 text-center" data-id="element-165" data-mp="3hx2877hduy01">
            <Button href="#pricing" className="w-full text-sm md:w-auto md:text-base" data-id="element-166" data-mp="3hwaddyvm14at">
              Empezar hoy con el Combo Completo →
            </Button>
          </div>
        </div>
      </section>
    </>;
}
function Metric({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="rounded-xl border border-line bg-ink p-3" data-id="element-167" data-mp="1b6cjk6jubz5m">
      <p className="text-xl font-black text-gold" data-id="element-168" data-mp="167sx851c4lcq">{value}</p>
      <p className="mt-1 text-[10px] font-bold leading-tight text-zinc-500" data-id="element-169" data-mp="166832gixn4fe">{label}</p>
    </div>;
}